import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaFilm,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ShortFilmProductionServicesInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Short Film Production Services in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Bring Your Story to Life</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Short Film Production</span> in Al
            Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our short film production services in **Al
            Barsha** create cinematic, narrative-driven films that captivate
            audiences. From concept to final cut, we craft compelling stories
            with stunning visuals, perfect for festivals, branding, or personal
            projects.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1599240211563-17590b1af857?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Film production
          "https://images.unsplash.com/photo-1578221569814-fd71a9718db5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Camera crew
          "https://images.unsplash.com/photo-1602491453631-e2a5ad90a131?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Editing suite
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Film"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Short Film Production in Al Barsha"
        description="We deliver cinematic short films that resonate with audiences."
        cards={[
          {
            icon: <FaFilm color="#ff5464" size={40} />,
            title: "Cinematic Storytelling",
            description: "Compelling narratives that leave a lasting impact.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Stunning Visuals",
            description: "High-quality footage with artistic flair.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Efficient Production",
            description:
              "Timely delivery to meet festival or project deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description:
              "Films optimized for festivals, online, or social media.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Creatives",
            description: "Al Barsha’s choice for short film production.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Full-Service Production",
            description: "From script to screen, we handle every detail.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Short Film Production Process"
        description={
          <Description>
            We bring your vision to life through a meticulous, creative process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Concept Development: Collaborate to refine your story or idea.
              </li>
              <li>Scripting: Craft a detailed script or storyboard.</li>
              <li>Pre-Production: Plan logistics, casting, and locations.</li>
              <li>Filming: Capture footage with top-tier cameras and crew.</li>
              <li>
                Post-Production: Edit with effects, sound design, and color
                grading.
              </li>
              <li>
                Delivery: Provide a polished film ready for your audience.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1533928298208-27ff66555d8d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Film production
          "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Camera crew
          "https://images.unsplash.com/photo-1543536448-1e76fc2795bf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Editing suite
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Short Film Wins in Al Barsha"
        description="Our short films have inspired audiences and earned recognition."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Festival Success",
            description:
              "Produced a short film screened at regional festivals.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Viral Impact",
            description:
              "Created a branded short film that gained online traction.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "95% satisfaction from short film clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Tell Your Story?</Subheading>}
        heading="Short Film Production in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional short film production
            services in Al Barsha. Create cinematic, impactful films that
            captivate and inspire—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1523207911345-32501502db22?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Camera crew
          "https://images.unsplash.com/photo-1501369762096-edcbbcf4ad81?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Editing suite
          "https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Film production
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
